/**
 * ManagerLegacyRetired.tsx — /#/manager-legacy
 *
 * W11-LastFourBroken: The legacy manager view relied on /api/manager/portfolio
 * which is no longer reliable and caused an infinite loading spinner.
 * This retired page replaces it with a clear redirect to the current
 * Manager Hub at /#/manager.
 */

export default function ManagerLegacyRetired() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#FAFAF7",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Inter, system-ui, sans-serif",
        padding: "24px",
      }}
    >
      <div
        style={{
          maxWidth: 460,
          background: "#FFFFFF",
          border: "1px solid #E5E5E7",
          borderRadius: 12,
          padding: "40px 36px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: "50%",
            background: "#F4F4F5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
          }}
        >
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
            <path d="M11 3L19 19H3L11 3Z" stroke="#6B6B70" strokeWidth="1.5" strokeLinejoin="round" />
            <path d="M11 9v4" stroke="#6B6B70" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="11" cy="15.5" r="0.75" fill="#6B6B70" />
          </svg>
        </div>
        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "#8E8E94",
            marginBottom: 10,
          }}
        >
          Retired view
        </div>
        <p style={{ fontSize: 16, fontWeight: 700, color: "#0B0B0F", margin: "0 0 10px" }}>
          This view has been retired.
        </p>
        <p style={{ fontSize: 13, color: "#6B6B70", margin: "0 0 28px", lineHeight: 1.6 }}>
          The legacy manager dashboard has been replaced by the Manager Hub, which provides
          team coaching queues, account audits, pipeline health, and forecast reviews in a
          single unified view.
        </p>
        <a
          href="#/manager"
          style={{
            display: "inline-block",
            padding: "10px 22px",
            background: "#0B0B0F",
            color: "#FFFFFF",
            borderRadius: 6,
            fontSize: 13,
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Go to Manager Hub
        </a>
      </div>
    </div>
  );
}
